export default __webpack_public_path__ + "static/media/discount3.9bd33be7.jpg";